import store from '@/store/store';
import genererDemandeImpression from '@/services/logistique/demandeImpression/genererDemandeImpression';
import { ETAT_POSE } from '@/configuration/logistique/demandeImpression/demandeImpressionConf';
import formatDate from '@/services/general/formatIsoDate';
import moment from 'moment';

export function fillDemandeImpressionWithData(demandeImpression, ligne, clients,
  campagnes, dispositifs) {
  const errors = [];
  const societe = store.getters['societe/societeActive'];
  demandeImpression.societeId = societe.id;
  demandeImpression.typeOtId = societe.typeOtImpressionId;
  demandeImpression.quantite = 1;
  demandeImpression.etat = ETAT_POSE;
  demandeImpression.dateDemande = formatDate(moment(ligne.date, 'DD/MM/YYYY'));
  demandeImpression.urlImage = ligne.image;

  const campagne = campagnes.find(c => c.libelle.toLowerCase()
    === ligne.libelleCampagne.toLowerCase());
  demandeImpression.campagneId = campagne.id;

  const client = clients.find(c => c.referenceExterne === ligne.refExterneTiers);
  demandeImpression.clientId = client.id;

  const dispositif = dispositifs.find(d => d.code === ligne.codeDispositif
    && ligne.refExterneTiers === d.emplacement.client.referenceExterne);
  demandeImpression.dispositifId = dispositif.id;

  if (errors.length > 0) throw errors;
  return demandeImpression;
}

export default function genererdemandeImpression(ligne, clients,
  campagnes, dispositifs) {
  const demandeImpression = genererDemandeImpression();
  return fillDemandeImpressionWithData(demandeImpression, ligne, clients, campagnes, dispositifs);
}
